import styled from 'styled-components';

export const Text = styled.p`
  margin: 0;
  padding-bottom: 116px;
  color: #a0abb8;
  font-size: 13px;
  line-height: 20px;
`;
